import { FirestoreDatabase } from '../index'
import { Collection } from 'constants/index'
import moment from 'moment/moment'

// Function to add attachment to an event's subcollection
export const addEventAttachments = async (eventId, attachments) => {
  try {
    const batch = FirestoreDatabase.batch()
    const attachmentsRef = FirestoreDatabase.collection(Collection.EVENTS)
      .doc(eventId)
      .collection('attachments')

    attachments.forEach((attachment) => {
      const docRef = attachmentsRef.doc()
      batch.set(docRef, { ...attachment, createdAt: moment().utc().valueOf() })
    })

    await batch.commit()
  } catch (error) {
    console.error('Error adding attachments:', error)
    throw error
  }
}

// Function to get all attachments for an event
export const getEventAttachments = async (eventId) => {
  try {
    const snapshot = await FirestoreDatabase.collection(Collection.EVENTS)
      .doc(eventId)
      .collection('attachments')
      .orderBy('uploadedAt', 'desc')
      .get()

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }))
  } catch (error) {
    console.error('Error fetching attachments:', error)
    throw error
  }
}

// Function to delete an attachment
export const deleteEventAttachment = async (eventId, attachmentId) => {
  try {
    // Delete from Firestore
    await FirestoreDatabase.collection(Collection.EVENTS)
      .doc(eventId)
      .collection('attachments')
      .doc(attachmentId)
      .delete()

    return true
  } catch (error) {
    console.error('Error deleting attachment:', error)
    throw error
  }
}

// Function to set up real-time listener for attachments
export const listenToEventAttachments = (eventId, callback) => {
  return FirestoreDatabase.collection(Collection.EVENTS)
    .doc(eventId)
    .collection('attachments')
    .orderBy('uploadedAt', 'desc')
    .onSnapshot(
      (snapshot) => {
        const attachments = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }))
        callback(attachments)
      },
      (error) => {
        console.error('Error listening to attachments:', error)
        callback([])
      }
    )
}
